import { PropsWithChildren, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SkipLink } from "@/components/_atoms/skip-link";
import { Link } from "@/components/_molecules/navigation-controls/link";

export default function AuthPageLayout({ children }: PropsWithChildren) {
  const { t } = useTranslation("auth");
  const logoUrl = useMemo(() => {
    return "/ark-logo-color-bg.png";
  }, []);

  return (
    <div className="flex h-screen w-screen">
      <SkipLink />
      <div className="flex w-full flex-col items-center justify-center gap-12 bg-background px-5 text-foreground lg:w-1/2">
        <div className="my-2 flex flex-row items-start gap-4">
          <img src={logoUrl} className="object-fit h-12 w-12" alt="Ark Climate" />
          <div className="-mt-1.5 flex flex-col items-start">
            <div className="text-2xl font-bold">{t("layout.title")}</div>
            <div className="text-sm">{t("layout.subtitle")}</div>
          </div>
        </div>

        <main id="main-content" tabIndex={-1} className="z-10 w-full max-w-md overflow-hidden rounded-sm border shadow-sm">
          {children}
        </main>

        <div className="max-w-md text-xs ">
          {t("layout.noAccountText")}
          <Link to="https://www.ark-climate.de/#kontakt" className="underline">
            {" "}
            {t("layout.requestAccount")}
          </Link>
        </div>
      </div>

      <div className="pointer-events-none relative hidden h-full w-1/2 lg:flex">
        <div className="absolute bottom-0 left-0 right-0 top-0 bg-black opacity-50"></div>
        <img src="/wallpaper-login.jpg" className="object-cover" alt="" />
      </div>
    </div>
  );
}
